import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { RouterParamsService } from '../../shared/services/router-params.service';
import { BaseEntityService } from '../entity-management/services/base/base-entity.service';
import { PersonCondition } from '../models/person-conditions';

@Injectable({
  providedIn: 'root',
})
export class PersonConditionsEntityService extends BaseEntityService<PersonCondition> {
  constructor(
    httpClient: HttpClient,
    routerParamsService: RouterParamsService,
  ) {
    super(
      httpClient,
      environment.apiUrl,
      { singular: 'personCondition', plural: 'personConditions', url: 'person-conditions' },
      routerParamsService
    );
    this.nameId = 'personConditionId';
  }
}
